import { optionList } from './formFields.js';
import { SearchableSelect } from '../components/SearchableSelect.jsx';

export function FormAnswerFields({ fields, values, onChange, disabled = false }) {
  return (
    <div className="stack">
      {fields.map((field) => (
        <div key={field.key} className="field">
          <span>
            {field.label}
            {field.required ? ' *' : ''}
          </span>
          {field.help ? <span className="muted small">{field.help}</span> : null}
          <FieldControl field={field} value={values[field.key]} disabled={disabled} onChange={onChange} />
        </div>
      ))}
    </div>
  );
}

function FieldControl({ field, value, disabled, onChange }) {
  const set = (next) => onChange(field.key, next);

  if (field.type === 'textarea') {
    return (
      <textarea rows={4} value={value ?? ''} disabled={disabled} required={field.required} onChange={(e) => set(e.target.value)} />
    );
  }

  if (field.type === 'select') {
    return (
      <SearchableSelect value={value ?? ''} disabled={disabled} required={field.required} onChange={(e) => set(e.target.value)}>
        <option value="">Select…</option>
        {optionList(field).map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </SearchableSelect>
    );
  }

  if (field.type === 'radio') {
    return (
      <div className="form-choice-list">
        {optionList(field).map((option) => (
          <label key={option} className="form-choice">
            <input
              type="radio"
              name={field.key}
              value={option}
              checked={value === option}
              disabled={disabled}
              onChange={() => set(option)}
            />
            <span>{option}</span>
          </label>
        ))}
      </div>
    );
  }

  if (field.type === 'checkbox') {
    return (
      <label className="form-choice">
        <input type="checkbox" checked={value === true || value === '1' || value === 'yes'} disabled={disabled} onChange={(e) => set(e.target.checked ? 'yes' : '')} />
        <span>Yes</span>
      </label>
    );
  }

  if (field.type === 'rating') {
    return (
      <div className="form-rating" role="group" aria-label={field.label}>
        {[1, 2, 3, 4, 5].map((score) => (
          <button
            key={score}
            type="button"
            className={String(value) === String(score) ? 'form-rating-btn is-on' : 'form-rating-btn'}
            disabled={disabled}
            onClick={() => set(String(score))}
          >
            {score}
          </button>
        ))}
      </div>
    );
  }

  const inputType = ['email', 'tel', 'url', 'number', 'date'].includes(field.type) ? field.type : 'text';

  return (
    <input
      type={inputType}
      value={value ?? ''}
      disabled={disabled}
      required={field.required}
      onChange={(e) => set(e.target.value)}
    />
  );
}
